// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navshadow[data-v-1ae6dca8]{position:absolute;width:120vw;left:-10rem;box-shadow:1px 1px 1px 1px #c4c4c4}", ""]);
// Exports
module.exports = exports;
